export const NoAuthRoutes = {
  login: '/',
  statusControl: '/status-control',
};

export const MainRoutes = {
  ...NoAuthRoutes,
  home: '/inicio',
  logout: '/cerrar-sesion',
  notFoundPage: '/404',
  check: '/fichaje',
  compartidos: '/compartidos',
  notificaciones: '/notificaciones',
  informacionyRecursos: '/informacion-y-recursos',
  notes: '/notas',
  paginas: '/paginas',
  paycheck: '/recibos',
  search: '/resultados-busqueda',
  team: '/equipo',
  viaticos: '/tu-arsat/viaticos',
  viaticosTuEquipo: '/equipo/viaticos/',
  viaje: '/tu-arsat/viaticos/viaje',
  delegaciondePermisos: '/equipo/delegacion-de-permisos',
} as const;
